// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__2wsvd","home":"style_home__2ks8l","player":"style_player__vv8he","kda":"style_kda__2opxu","champ":"style_champ__2EUpr","away":"style_away__1bCwa"};